import alt from "../alt";

class OrderActions {
  constructor() {
    this.generateActions(
      "updateOrder",
      "updateOrders",
      "fetchOne",
      "fetchMore",
      "fetchAll",
      "fetchAllForEventBucket",
      "fetchAllForPerson",
      "fetchFailed",
      "resendConfirmation",
      "resendGiftNotification",
      "resendConfirmationFailed",
      "refundFailed",
      "clearErrors",
      "downloadReceipt",
      "downloadDonationReceipt",
      "reset"
    );
  }

  edit(id, values) {
    return { id, values };
  }

  refund(id, amount) {
    return { id, amount };
  }
}

export default alt.createActions(OrderActions);



// WEBPACK FOOTER //
// ./src/app/actions/OrderActions.js